export default __webpack_public_path__ + "static/media/bb.ef5d27b1.png";